import React, { useState } from 'react';
import { createContext } from 'react';
import { TokenResponse } from '../../types/TokenResponse';

const ClientId = process.env.REACT_APP_CLIENT_ID || '';
const Scope = process.env.REACT_APP_SCOPE || '';
const RedirectUrl = process.env.REACT_APP_REDIRECT_URL || '';

const AccessTokenKey = "AccessToken";
const TimeExpiresKey = "AccessTimeExpires";

interface IAuthenticationContext {
    isAuthenticated: () => boolean;
    logout: () => void;
    login: () => void;
    setTokenResponse: (token: TokenResponse) => void;
    getAccessToken: () => string;
    getMusicToken: () => string;
}

const AuthenticationContext = createContext<IAuthenticationContext>({
    isAuthenticated: () => false,
    logout: () => {},
    login: () => {},
    setTokenResponse: () => {},
    getAccessToken: () => '',
    getMusicToken: () => '',
});

type AccessToken = {
    Token: string | null;
    TimeExpires: Date | null;
}

const AuthenticationProvider: React.FC<{children: React.ReactNode}> = ({ children }) => {
    const token = localStorage.getItem(AccessTokenKey);
    const date = localStorage.getItem(TimeExpiresKey);
    const timeExpires = date === null ? null : new Date(date);
    const [ accessToken, setAccessToken ] = useState<AccessToken | undefined>({
        Token: token,
        TimeExpires: timeExpires
    });

    const isAuthenticated = () => {
        if (accessToken?.TimeExpires === undefined || accessToken?.TimeExpires === null) {
            return false;
        }

        const currentTime =  new Date();
        const TimeExpires = new Date(accessToken.TimeExpires );
        if (currentTime < TimeExpires) {
            return true;
        }

        logout();
        return false;
    };

    const getAccessToken = () => {
        if (isAuthenticated() === true) {
            return accessToken?.Token ?? '';
        }
                
        logout();
        return '';
    }

    const getMusicToken = () => {
        return accessToken?.Token?.substring(0, 10) ?? '';
    }
    
    const setTokenResponse = (tokenResponse: TokenResponse) => {
        const milliseconds = tokenResponse.expiresIn * 1000;
        const currentTime = new Date();
        const expireTime = new Date(currentTime.getTime() + milliseconds);
        
        localStorage.setItem(AccessTokenKey, tokenResponse.accessToken);
        localStorage.setItem(TimeExpiresKey, expireTime.toString());
        setAccessToken({
            Token: tokenResponse.accessToken,
            TimeExpires: expireTime
        });
    }

    const logout = () => {
        localStorage.removeItem(AccessTokenKey);
        localStorage.removeItem(TimeExpiresKey);
        setAccessToken(undefined);
        window.location.href = RedirectUrl;
    }

    const login = () => {
        if (isAuthenticated()) {
            return;
        }

        const loginUrl = `https://login.live.com/oauth20_authorize.srf?client_id=${ClientId}&scope=${encodeURI(Scope)}&response_type=code&redirect_uri=${encodeURI(RedirectUrl)}`;        
        window.location.href = loginUrl;
    }

    return (
        <AuthenticationContext.Provider value={{ isAuthenticated, logout, login, setTokenResponse, getAccessToken, getMusicToken }}>
            {children}
        </AuthenticationContext.Provider>
    );
};

export { AuthenticationContext, AuthenticationProvider };